// extracted by mini-css-extract-plugin
export default {"mainActions":"MainActions_mainActions__kbdOK","title":"MainActions_title__w-FS2","actions":"MainActions_actions__SMm1n"};